import axios from 'axios';
import store from '../store/store';
import { enterpriseExpire, individualExpire } from '../api/personal';
import ElementUI from 'element-ui';


// console.log(process.env)
let baseURL = '';
// if (process.env.NODE_ENV == 'production') {
//     baseURL = location.protocol + '//' + location.host;
// } else {
//     baseURL = process.env.VUE_APP_BASE_API;
// }
baseURL = process.env.VUE_APP_BASE_API;

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    baseURL: baseURL,
    timeout: 5000
});

service.interceptors.request.use(
    config => {
        if (sessionStorage.getItem('token') !== null) {
            config.headers['authorization'] = sessionStorage.getItem('token');
        }
        if (localStorage.getItem('userData')) {
            let obj = JSON.parse(localStorage.getItem('userData'));
            config.headers['Platformsn'] = obj.platform_sn;
        } else {
            config.headers['Platformsn'] = '';
        }
        if (sessionStorage.getItem('shenfen')) {
            var obj = JSON.parse(sessionStorage.getItem('shenfen'));
            config.headers['Comid'] = obj.com_id;
        } else {
            config.headers['Comid'] = 0;
        }

        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);


service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data.code == 401) {
                sessionStorage.removeItem('token');
                location.reload();
                return;
            }
                // else if (response.data.code==405){
                //     ElementUI.Message.error('请前往首页进行个人认证')
                //     return
                // }
                //认证
                // else if(response.data.code==403){
                //     console.log(response);
                //     //E签宝个人认证授权过期
                //     individualExpire().then(res=>{
                //         if(res.code==200){
                //             window.location.href = res.data.auth_url
                //             return
                //         }else{
                //             ElementUI.Message.error(res.msg);
                //         }
                //     })
                // }else if (response.data.code==404){
                //     //E签宝企业认证授权过期
                //     enterpriseExpire().then(res=>{
                //         if(res.code==200){
                //             window.location.href = res.data.auth_url
                //         }else{
                //             ElementUI.Message.error(res.msg);
                //         }
                //     })
            // }
            else {
                return response.data;
            }
        }
        return response.data;
        // else {
        //    return  Promise.reject();
        // }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;
